import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["api"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useRef, useState } from 'react';

/**
 * Api request hook.
 *
 * @author Ihar Kazlouski
 * @function useApi
 * @category helper
 * @return {ApiReturn} return api state.
 */
function useApi(_ref) {
  var api = _ref.api,
      props = _objectWithoutProperties(_ref, _excluded);

  var controllerRef = useRef(new AbortController());
  var clearApi = useRef(false);

  var _useState = useState(!(props !== null && props !== void 0 && props.deferred)),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var handleRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var params,
          resp,
          _error,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 0 && _args[0] !== undefined ? _args[0] : props;
              _context.prev = 1;

              if (!clearApi.current) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              if (error) {
                setError(false);
              }

              setLoading(true);
              _context.next = 8;
              return api.call(null, _objectSpread({
                signal: controllerRef.current.signal,
                abortController: controllerRef.current,
                body: params === null || params === void 0 ? void 0 : params.body
              }, params));

            case 8:
              resp = _context.sent;

              if (!clearApi.current) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              setData(resp.data);
              _context.next = 20;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              _error = _context.t0;

              if (!clearApi.current) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              setError(_error);

            case 20:
              _context.prev = 20;

              if (!clearApi.current) {
                setLoading(false);
              }

              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14, 20, 23]]);
    }));

    return function handleRequest() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var controller = controllerRef.current;

    if (!(props !== null && props !== void 0 && props.deferred)) {
      void handleRequest(props);
    }

    return function () {
      clearApi.current = true;

      if (controller) {
        controller.abort();
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);
  return {
    loading: loading,
    data: data,
    error: error,
    update: handleRequest
  };
}

export { useApi };